import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useState} from 'react';
import {useEffect} from 'react';
import axios from 'axios';
import cat from '../../assets/extra/cat.svg';
import fox from '../../assets/extra/fox.svg';
import pig from '../../assets/extra/pig.svg';
import bird from '../../assets/extra/bird.svg';

axios.defaults.withCredentials = true;

function HomePage() {
    let animals = [cat, fox, pig, bird];
    let animal = animals[Math.floor(Math.random() * animals.length)];
    
    const [isMdOrLess, setIsMdOrLess] = useState(window.innerWidth <= 768);
    
    const handleResize = () => {
        setIsMdOrLess(window.innerWidth < 768);
    };
    
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    return (
        <div className={'container-fluid center h-100 flex-grow-1 ' + (isMdOrLess ? 'smallLoginBackground' : 'completedActivityBackground')}>
            <div className='completed-container'>
                <div className='completed-title'>
                    <h1>Hai completato l'attività</h1>
                    <h1>Continua così!</h1>
                </div>
                <img src={animal} alt="animal" className="animal-svg"/>
            </div>
        </div>
    );
}

export default HomePage;
